import React from "react";
import HasOptionList from "./HasOptionList";

export default class RadioGroup extends HasOptionList {

    static defaultProps = {
        id: undefined,
        name: undefined,
        value: undefined,
        label: undefined,
        disabled: false,
        hideIfNoOptions: false,
        disableIfSingleOption: false,
        hideIfSingleOption: false,
        onChange: undefined,
        getLabel: undefined,
        getValue: undefined,
    };

    ref = React.createRef();

    render() {
        const props = this.props;
        const selectedOptionIndex = props.options.findIndex(o => this.isSameValue(this.getValue(o),props.value));
        const options = this.getOptions();

        if (props.hideIfNoOptions && options.length == 0 || props.hideIfSingleOption && options.length < 2) {
            return null;
        }

        return (
            <div className={this.classNameGroup()}>
                {props.label && <label htmlFor={props.name}>{props.label}</label>}
                {options.map((option, index) => (
                    <div key={index}>
                        <label htmlFor={`${props.name}_${index}`}>
                            <input type="radio" name={props.name} id={`${props.name}_${index}`}
                                   value={index}
                                   checked={index == selectedOptionIndex}
                                   onChange={event => {
                                       const v = this.getValue(option);
                                       this.onChange(v,event);
                                   }}
                                   disabled={props.disabled || (props.disableIfSingleOption && options.length < 2)}
                                   />
                            <span>{this.getLabel(option)}</span>
                        </label>
                    </div>
                ))}
            </div>
        );
    }
}
